/* Synchronizes the existing touch-scroll gallery; does not create another slider. */
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-mango-mobile-pagination]').forEach((pagination) => {
      if (pagination.dataset.mmpInitialized === 'true') return;
      const gallery = pagination.closest('product-images');
      const track = gallery?.querySelector('[data-product-media-list]');
      if (!track) return;
      pagination.dataset.mmpInitialized = 'true';
      let slides = [];
      let dots = [];
      let frame = 0;
      const visibleSlides = () => [...track.querySelectorAll('.product__slide')].filter((slide) => {
        const style = getComputedStyle(slide);
        return style.display !== 'none' && style.visibility !== 'hidden' && !slide.hidden && slide.getClientRects().length > 0;
      });
      const selected = () => {
        const left = track.getBoundingClientRect().left;
        let index = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const d = Math.abs(slide.getBoundingClientRect().left - left);
          if (d < distance) { distance = d; index = i; }
        });
        return index;
      };
      const update = () => {
        frame = 0;
        if (!dots.length) return;
        const current = selected();
        dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
          dot.setAttribute('aria-label', `Imagen ${i + 1} de ${dots.length}`);
        });
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const rebuild = () => {
        const next = visibleSlides();
        if (next.length === slides.length && next.every((s, i) => s === slides[i])) { schedule(); return; }
        slides = next;
        pagination.replaceChildren();
        dots = slides.map((slide, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'mango-mobile-pagination__dot';
          dot.addEventListener('click', () => slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
          pagination.appendChild(dot);
          return dot;
        });
        pagination.hidden = slides.length < 2;
        schedule();
      };
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', rebuild, { passive: true });
      const observer = new MutationObserver(rebuild);
      observer.observe(track, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      rebuild();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
